// extracted by mini-css-extract-plugin
export default {"video":"rjiTB","fullscreen":"wyd30"};